import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import BudgetsList from './BudgetsList';

function Budgets() {
  return (
    <Routes>
      <Route path="/" element={<BudgetsList />} />
      <Route path="*" element={<Navigate to="/budgets" replace />} />
    </Routes>
  );
}

export default Budgets; 